<template>
    <v-menu :offset-y="!horizontal" :offset-x="horizontal" :close-on-content-click="false" v-model="showMenu" :attach="attach">
        <template v-slot:activator="{ on }">
            <v-card v-on="on" text flat class="primary primarytext--text text-caption d-flex" :class="horizontal ? 'flex-row my-2' : 'flex-column text-center'">
                <div class="pt-2 pb-2"><v-icon class="primarytext--text" v-text="icon" :class="{'px-2': horizontal}" /></div>
                <div class="mt-n1 flex-grow-1" v-text="title" :class="{'align-self-center': horizontal, 'px-2': horizontal}" />
                <v-icon class="primarytext--text mt-n2">{{horizontal ? 'mdi-chevron-right' : 'mdi-chevron-down' }}</v-icon>
            </v-card>
        </template>

        <v-list dense>
            <slot name="items" v-bind:items="items" v-bind:hide="hideMenu" v-if="$scopedSlots.items" />
            <div v-else style="overflow-y: auto; max-height: 70vh; max-height: 70dvh" class="mx-2">
                <v-text-field v-if="search" :placeholder="searchText" dense v-model="filterSearchText" clearable class="mr-2" />
                <filter-button-row v-if="all" icon="mdi-playlist-check" :name="$translate(allTitle)" :value="selected.length == 0 || selected.length == items.length" @input="selectAll($event)" />

                <v-divider v-if="search || all" class="mt-2 mb-4" />

                <template v-if="categories">
                    <div v-for="category in filteredCategories" :key="category.id">
                        <filter-button-row
                            :value="!items.filter(i => categoryMatch(category, i)).find(i => !selected.includes(i.id))"
                            :name="category.name"
                            :color="null"
                            :image="category.imagekey"
                            @input="setCategory(category, $event)"
                        />
                        <filter-button-row
                            v-for="item in filteredItems.filter(i => categoryMatch(category, i))"
                            :key="item.id"
                            :value="selected.includes(item.id)"
                            @input="setItem(selected, item.id, $event)"
                            :icon="item.icon"
                            :color="showColorImageCircle ? item.color : null"
                            :name="item[itemName]"
                            :image="item[itemImage]"
                            class="ml-8"
                        />
                    </div>
                </template>
                <filter-button-row
                    v-else
                    v-for="item in filteredItems"
                    :key="item.id"
                    :value="selected.includes(item.id)"
                    @input="setItem(selected, item.id, $event)"
                    :icon="item.icon"
                    :color="showColorImageCircle ? item.color : null"
                    :name="item[itemName]"
                    :image="item[itemImage]"
                    :showColorImageCircle="showColorImageCircle"
                />
            </div>
        </v-list>
    </v-menu>
</template>

<script>
import FilterButtonRow from './FilterButtonRow.vue'
export default {
    name: 'zoezi-filter-button',

    props: {
        value: {},
        title: {
            type: String
        },
        icon: {
            type: String
        },
        items: {
            type: Array
        },
        itemName: {
            type: String,
            default: 'name'
        },
        itemImage: {
            type: String,
            default: 'imagekey'
        },
        all: {
            type: Boolean,
            default: true
        },
        allTitle: {
            type: String,
            default: 'ALL'
        },
        allIcon: {
            type: String
        },
        search: {
            type: Boolean,
            default: false
        },
        searchText: {
            type: String
        },
        horizontal: {
            type: Boolean,
            default: false
        },
        attach: {
        },
        categories: {
            type: Array,
            default: null
        },
        categoryMatch: {
            type: Function,
            default: null
        },
        showColorImageCircle: {
            type: Boolean,
            default: true
        }
    },

    components: {
        FilterButtonRow
    },

    watch: {
        value(value) {
            this.selected = value;
        },
        selected() {
            this.$emit('input', this.selected);
        },
        showMenu(show) {
            if (show) {
                this.filterSearchText = '';
            }
        }
    },

    data() {
        return {
            selected: this.value || [],
            showMenu: false,
            filterSearchText: ''
        };
    },

    computed: {
        selectedText() {
            if (!this.selected || this.selected.length == 0) {
                return this.$translate('ALL');
            }

            if (this.selected.length == 1) {
                return this.items.find(x => x.id == this.selected[0])[this.itemName];
            }

            return this.$translate('{0} selected').format(this.selected.length);
        },
        filteredItems() {
            if (!this.search || !this.filterSearchText) {
                return this.items;
            }
            let s = this.filterSearchText.toLowerCase();
            return this.items?.filter(x => !s || x[this.itemName].toLowerCase().includes(s))
        },
        filteredCategories() {
            if (!this.search || !this.filterSearchText) {
                return this.categories;
            }
            let s = this.filterSearchText.toLowerCase();
            let categoryContainsMatches = (category) => {
                return this.filteredItems.find(i => this.categoryMatch(category, i))
            }
            return this.categories?.filter(x => !s || x.name.toLowerCase().includes(s) || categoryContainsMatches(x))
        }
    },
    methods: {
        setItem(list, id, selected) {
            let i = list.indexOf(id);
            if (selected && i == -1) {
                list.push(id);
            } else if (!selected && i != -1) {
                list.splice(i, 1);
            }
        },
        hideMenu() {
            this.showMenu = false;
        },
        selectAll(selected) {
            if (selected) {
                this.selected = [];
            }
        },
        setCategory(category, selected) {
            this.items.filter(i => this.categoryMatch(category, i)).forEach(i => {
                this.setItem(this.selected, i.id, selected)
            })
        }
    }
}
</script>
